import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"

import DropdownMenu from "../DropdownMenu"

import Name from "~/components/traffic/lookup/Forms/Inputs/NameInput"
import GenderAndDateInput from "~/components/traffic/lookup/Forms/Inputs/GenderAndDateInput"

import InputTitle from "./InputTitle"
import withTranslations from "~/components/_hocs/withTranslations"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  firstName: all.store.trafficLookup.firstName,
  middleName: all.store.trafficLookup.middleName,
  lastName: all.store.trafficLookup.lastName,
  changeName: all.store.trafficLookup.changeName,
  changeGender: all.store.trafficLookup.changeGender,
  gender: all.store.trafficLookup.gender,
  changeDOBString: all.store.trafficLookup.changeDOBString,
  DOBString: all.store.trafficLookup.DOBString,
}))
@observer
class NameDOBGenderInput extends Component {
  handleRadio = (input) => {
    if (input === "male") {
      this.props.changeGender("male")
    } else {
      this.props.changeGender("female")
    }
  }

  handleDOBString = (event) => {
    const { value } = event.target
    // const regex = /[0-9]/
    // const isNumber = regex.test(value)
    // if (isNumber) {
    this.props.changeDOBString(value)
    // }
  }

  // handleDOBKeyDown = (e) => {
  //   if (e.keyCode === 8) {
  //     this.props.changeDOBString(true, null)
  //   }
  // }

  handleChange = (e) => {
    this.props.changeName(e.target.name, e.target.value)
  }

  render() {
    const firstNameErrorHandler = this.props.validateDisplayMessage("firstName")
    const lastNameErrorHandler = this.props.validateDisplayMessage("lastName")
    const nameErrorHandler = firstNameErrorHandler || lastNameErrorHandler
    const { gender, DOBString } = this.props
    const isMale = gender ? gender === "male" : true
    const dateErrorHandler = this.props.validateDisplayMessage("DOBString")
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate("label")}
          <Spacer direction="width" mobile={11} desktop={11} />
          <DropdownMenu columnNumber="one" />
        </InputTitle>
        <Spacer desktop={16} mobile={4} />
        <Name
          firstName={this.props.firstName}
          middleName={this.props.middleName}
          lastName={this.props.lastName}
          handleChange={this.handleChange}
          error={nameErrorHandler}
        />
        <FormError error={nameErrorHandler} />
        <Spacer mobile={4} desktop={14} />
        <GenderAndDateInput
          radio1Checked={isMale}
          radio2Checked={!isMale}
          handleRadio={this.handleRadio}
          handleDOB={this.handleDOBString}
          DOBString={DOBString}
          // handleDOBKeyDown={this.handleDOBKeyDown}
          error={dateErrorHandler}
        />
      </Wrap>
    )
  }
}

export default withTranslations(
  NameDOBGenderInput,
  "form.traffic.nameDOBGender"
)
